import dynamic from "next/dynamic";

import { Container } from "@/features/common/components/Container";
import { PaginationProvider } from "@/features/common/contexts/usePaginationContext";
import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import { SiteLayout } from "@/features/layout/SiteLayout";
import {
  ModelOrderByWithRelationInput,
  ModelWhereInput,
  useModelsCountQuery,
} from "@/generated/graphql-hooks";

const ModelList = dynamic(
  () => import("@/features/model/components/modeList/ModelList"),
);

const ModelListPage = () => {
  const { query } = useRequestQuery<
    ModelWhereInput,
    ModelOrderByWithRelationInput
  >();

  const { data: { modelsCount } = {} } = useModelsCountQuery({
    where: { ...query?.where },
  });

  return (
    <Container className="pt-1 pb-12 sm:grid sm:grid-cols-4 sm:gap-x-8 sm:pt-12 sm:pb-24">
      <PaginationProvider>
        <ModelList count={modelsCount} query={query} />
      </PaginationProvider>
    </Container>
  );
};

export default ModelListPage;

ModelListPage.getLayout = function getLayout(page) {
  return <SiteLayout>{page}</SiteLayout>;
};
